<fm-context-menu [position]="menuData.clickPosition"
  [isRightClickDisabled]="true"
  class="map-menu-container"
  (closed)="onMenuClosed()"
  (copyCoordinatesClicked)="onCopyCoordinates($event)"
  [menuName]="menuData.markerInfo.title"
  [latLng]="menuData.markerInfo?.latLng">
  <fm-context-menu-panel>
    <fm-context-menu-item *ngIf="userPermissions.findNearest"
      [hasSeparator]="true"
      id="lnk-vehicle-find-nearest"
      (click)="onFindNearestClicked()"
      a7s-id="live-map-vehicle-contextual-menu-find-nearest">
      <a i18n="@@S_FIND_NEAREST">Find nearest</a>
    </fm-context-menu-item>
    <fm-context-menu-item *ngIf="userPermissions.viewReplay"
      id="lnk-vehicle-view-replay"
      (click)="onViewReplayClicked()"
      a7s-id="live-map-vehicle-contextual-menu-view-replay">
      <a i18n="@@S_VIEW_REPLAY">View replay</a>
    </fm-context-menu-item>
    <fm-context-menu-item *ngIf="userPermissions.runDailyReport"
      id="lnk-vehicle-run-daily-report"
      (click)="onRunDailyReportClicked()"
      a7s-id="live-map-vehicle-contextual-menu-run-daily-report">
      <a i18n="@@S_RUN_JOURNEY_REPORT">Run daily report</a>
    </fm-context-menu-item>
    <fm-context-menu-item *ngIf="userPermissions.runDetailedReport"
      [hasSeparator]="true"
      id="lnk-vehicle-run-detailed-report"
      (click)="onRunDetailedReportClicked()"
      a7s-id="live-map-vehicle-contextual-menu-run-detailed-report">
      <a i18n="@@S_RUNDETAILEDREPORT">Run detailed report</a>
    </fm-context-menu-item>
    <fm-context-menu-item id="lnk-vehicle-zoom-to"
      (click)="onZoomToClicked()"
      a7s-id="live-map-vehicle-contextual-menu-zoom-to">
      <a i18n="@@S_ZOOM_TO">Zoom to</a>
    </fm-context-menu-item>
    <fm-context-menu-item id="lnk-vehicle-street-view"
      [isDisabled]="!menuData.streetViewAvailable"
      (click)="onStreetViewClicked()"
      a7s-id="live-map-vehicle-contextual-menu-street-view">
      <a i18n="@@S_STREET_VIEW">Street view</a>
    </fm-context-menu-item>
    <fm-context-menu-item *ngIf="userPermissions.createGeofence"
      id="lnk-vehicle-create-geofence-here"
      (click)="onCreateGeofenceClicked()"
      a7s-id="live-map-vehicle-contextual-menu-create-a-geofence-here">
      <a i18n="@@S_CREATE_A_GEOFENCE_HERE">Create a Geofence here</a>
    </fm-context-menu-item>
    <fm-context-menu-item [hasSeparator]="true"
      id="lnk-vehicle-remove-from-live-map"
      (click)="onRemoveFromLiveMapClicked()"
      a7s-id="live-map-vehicle-contextual-menu-remove-from-live-map">
      <a i18n="@@S_REMOVE_FROM_MAP">Remove from Live Map</a>
    </fm-context-menu-item>
    <fm-context-menu-item *ngIf="userPermissions.directions"
      id="lnk-vehicle-directions"
      a7s-id="live-map-vehicle-contextual-menu-directions">
      <a i18n="@@S_DIRECTIONS">Directions</a>
      <fm-context-menu-panel>
        <fm-context-menu-item id="lnk-vehicle-get-directions-to-here"
          (click)="onGetDirectionToClicked()"
          a7s-id="live-map-vehicle-contextual-menu-get-directions-to-here">
          <a i18n="@@S_GET_DIRECTIONS_TO_HERE">Get Directions to here</a>
        </fm-context-menu-item>
        <fm-context-menu-item id="lnk-vehicle-get-directions-from-here"
          (click)="onGetDirectionFromClicked()"
          a7s-id="live-map-vehicle-contextual-menu-get-directions-from-here">
          <a i18n="@@S_GET_DIRECTIONS_FROM_HERE">Get Directions from here</a>
        </fm-context-menu-item>
      </fm-context-menu-panel>
    </fm-context-menu-item>
    <ng-template #editDriver>
      <fm-context-menu-item id="lnk-vehicle-edit-driver"
        (click)="onEditDriverClicked()"
        a7s-id="live-map-vehicle-contextual-menu-edit-driver">
        <a i18n="@@S_EDITDRIVER">Edit Driver</a>
      </fm-context-menu-item>
    </ng-template>
    <ng-template #sendAMessage>
      <fm-context-menu-item id="lnk-vehicle-send-message"
        (click)="onSendMessageClicked()"
        a7s-id="live-map-vehicle-contextual-menu-send-a-message">
        <a i18n="@@S_SEND_AN_EMAIL_OR_SMS">Send a Message</a>
      </fm-context-menu-item>
    </ng-template>
    <fm-context-menu-item *ngIf="editMenuItems > 1"
      id="lnk-vehicle-options"
      a7s-id="live-map-vehicle-contextual-menu-vehicle-options">
      <a i18n="@@S_VEHICLE_OPTIONS">Vehicle options</a>
      <fm-context-menu-panel>
        <fm-context-menu-item *ngIf="showEditVehicle"
          id="lnk-vehicle-edit"
          (click)="onEditVehicleClicked()"
          a7s-id="live-map-vehicle-contextual-menu-edit-vehicle">
          <a i18n="@@S_EDIT_VEHICLE">Edit Vehicle</a>
        </fm-context-menu-item>
        <ng-container *ngIf="showEditDriver">
          <ng-container *ngTemplateOutlet="editDriver"></ng-container>
        </ng-container>
        <ng-container *ngIf="showSendMessage">
          <ng-container *ngTemplateOutlet="sendAMessage"></ng-container>
        </ng-container>
      </fm-context-menu-panel>
    </fm-context-menu-item>
    <fm-context-menu-item *ngIf="editMenuItems === 1 && showEditVehicle"
      id="lnk-vehicle-edit"
      (click)="onEditVehicleClicked()"
      a7s-id="live-map-vehicle-contextual-menu-edit-vehicle">
      <a i18n="@@S_EDIT">Edit</a>
    </fm-context-menu-item>
    <ng-container *ngIf="editMenuItems === 1 && showEditDriver">
      <ng-container *ngTemplateOutlet="editDriver"></ng-container>
    </ng-container>
    <ng-container *ngIf="editMenuItems === 1 && showSendMessage">
      <ng-container *ngTemplateOutlet="sendAMessage"></ng-container>
    </ng-container>
    <fm-context-menu-item *ngIf="menuData.markerInfo.hasNavigationDevice && (userPermissions.sendStop || userPermissions.viewStops || userPermissions.viewMessages)"
      id="lnk-vehicle-dispatch"
      a7s-id="live-map-vehicle-contextual-menu-dispatch">
      <a i18n="@@S_DISPATCH">Dispatch</a>
      <fm-context-menu-panel>
        <fm-context-menu-item *ngIf="userPermissions.sendStop"
          id="lnk-vehicle-send-stop"
          (click)="onSendStopClicked()"
          a7s-id="live-map-vehicle-contextual-menu-send-stop">
          <a i18n="@@S_SENDSTOP">Send Stop</a>
        </fm-context-menu-item>
        <fm-context-menu-item *ngIf="userPermissions.viewStops"
          id="lnk-vehicle-view-stops"
          (click)="onViewStopsClicked()"
          a7s-id="live-map-vehicle-contextual-menu-view-stops">
          <a i18n="@@S_VIEWSTOPS">View Stops</a>
        </fm-context-menu-item>
        <fm-context-menu-item *ngIf="userPermissions.viewMessages"
          id="lnk-vehicle-view-messages"
          (click)="onViewMessagesClicked()"
          a7s-id="live-map-vehicle-contextual-menu-view-messages">
          <a i18n="@@S_VIEWMESSAGES">View Messages</a>
        </fm-context-menu-item>
      </fm-context-menu-panel>
    </fm-context-menu-item>
    <fm-context-menu-item *ngIf="menuData.markerInfo.hasNavigationDevice && userPermissions.vehicleSendToGarmin"
      id="lnk-vehicle-send-location-to-garmin"
      (click)="onLocationToGarminClicked()"
      a7s-id="live-map-vehicle-contextual-menu-send-location-to-a-garmin">
      <a i18n="@@S_SEND_LOCATION_TO_GARMIN">Send location to a Garmin</a>
    </fm-context-menu-item>
    <fm-context-menu-item *ngIf="userPermissions.roadSideAssistance || userPermissions.roadSideAssistanceMarketingLinkEnabled"
      id="lnk-vehicle-roadside-assistance"
      [attr.a7s-id]="userPermissions.roadSideAssistance ? 'live-map-map-contextual-menu-rsa' : 'live-map-vehicle-contextual-menu-rsa-marketing'"
      (click)="onRoadsideAssistanceClicked()">
      <a i18n="@@S_RSA_TILE">Roadside Assistance</a>
    </fm-context-menu-item>
    <fm-context-menu-item *ngIf="isPingMVPEnabled"
      id="lnk-vehicle-troubleshoot-vehicle"
      (click)="onTroubleshootVehicleClicked()"
      a7s-id="live-map-vehicle-contextual-menu-device-health-check">
      <a i18n="@@S_DEVICE_HEALTH_CHECK">Device Health Check</a>
    </fm-context-menu-item>
  </fm-context-menu-panel>
</fm-context-menu>